/** @jsxImportSource react */
import type { SVGProps } from 'react';
const CheckCircleOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M17.568 9.565a.8.8 0 0 0-1.132-1.13l-5.932 5.937-2.938-2.938a.8.8 0 1 0-1.132 1.132l3.505 3.503a.8.8 0 0 0 1.131 0z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.5 12a9.5 9.5 0 1 1-19 0 9.5 9.5 0 0 1 19 0M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
      clipRule="evenodd"
    />
  </svg>
);
export default CheckCircleOutline;
